import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect-external',
  template: '<p>Redirecting to storen-reviews</p>'
})
export class RedirectExternalComponent implements OnInit {
  ngOnInit(): void {
    window.location.href = 'https://www.syngenta-us.com/c/storen-reviews/?utm_campaign=ssp-decommission-redirect&utm_medium=referral&utm_source=vanity-url&utm_term=ssp-redirect';
  }
}
